import { create, read, remove } from '@/api/rest';

const projectManagementPage = {
  task: async (id) => await read(`/project-management/task/${id}`),
  tasks: async (options) =>
    await read('/project-management/tasks?' + options.toString()),

  /**
   * @deprecated Use api.projectTask.create() or api.projectTask.update() instead of this method.
   * @param {*} data
   * @returns
   */
  saveTask: async (data) => await create('/project-management/save-task', data),
  saveCheckpoint: async (data) =>
    await create('/project-management/save-checkpoint', data),

  /**
   * @deprecated Use api.projectTask.remove() instead of this method.
   * @param {*} data
   * @returns
   */
  deleteTask: async (data) =>
    await create('/project-management/delete-task', data),
  deleteCheckpoint: async (id) =>
    await remove(`/project-management/delete-checkpoint/${id}`),
};

export default projectManagementPage;
